<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2025-05-13 10:07:22
 * @LastEditTime : 2025-06-12 10:55:50
 * @LastEditors  : yangxr
 * @Description  : 对接表格组件
 * @FilePath     : \icps_fb\src\views\platform\ICPS\Wise\docking\accessorySheet\tableMain.vue
-->
<template>
    <div>
        <!-- <div class="card_nav">
            <div></div>
            <div>
                <el-dropdown :hide-on-click="false" trigger="click" style="margin: 0 20px">
                    <el-link :underline="false">
                        <span class="el-icon--left">
                            <i class="iconfont iconicon_button_filtrate"></i>
                        </span>
                        筛选
                    </el-link>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="(item, index) in table" :key="index">
                            <el-checkbox v-model="item.status" @change="changeTable">{{ item.label }}</el-checkbox>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div> -->
        <div class="card_info">
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
                style="width: 100%" :height="height > 0 ? height : ''" :data="tableData" tooltip-effect="dark"
                 show-summary :summary-method="getSummaries">
                <template v-for="(item, index) in table">
                    <el-table-column v-if="item.children" :key="`children-${index}`" :label="item.label" align="center"
                        :width="item.width" :prop="item.prop">
                        <template v-for="(item2, index2) in item.children">
                            <el-table-column v-if="item2" :key="index2" :label="item2.label" align="center"
                                :width="item2.width" :prop="item2.prop">
                                <template slot-scope="scope">
                                    <span>{{ scope.row[item2.prop] }}</span>
                                </template>
                            </el-table-column>
                        </template>
                    </el-table-column>
                    <el-table-column v-else :key="`no-children-${index}`" :label="item.label" align="center"
                        :width="item.width" :prop="item.prop">
                        <template slot-scope="scope">
                            <span>{{ scope.row[item.prop] }}</span>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
        </div>
    </div>
</template>
  
<script>
export default {
    name: "tableMain",
    props: {
        tableData: {
            type: Array,
            default: () => [],
        },
        height: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            table: [
                { label: "材料名称", prop: "materialName", status: true, width: "auto" },
                { label: "期初数", prop: "beginAmount", status: true, width: "200" },
                { label: "收入", prop: "receiveAmount", status: true, width: "200" },
                {
                    label: "耗用", prop: "", status: true, width: "150", children: [
                        { label: "自行修理", prop: "manufactureAmount", status: true, width: "150" },
                        { label: "机械费用", prop: "productMachineAmount", status: true, width: "150" },
                        { label: "内部调出", prop: "noGxExpend", status: true, width: "150" },
                        { label: "合计", prop: "amountAll", status: true, width: "150" },
                    ]
                },
                { label: "结存", prop: "endAmount", status: true, width: "200" },
            ],
            tableLoading: false,
            needMergeArr: [
                "stationName",
                "businessTime",
                "mianBodyName",
                "materil",
            ],
            rowMergeArrs: [],
        };
    },
    watch: {
        // tableData(val) {
        //     this.rowMergeArrs = this.rowMergeHandle(this.needMergeArr, val);
        // },
    },
    methods: {
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                } else if (index == 1 && index== 2 && index == 3&& index == 4) {
                    sums[index] = '';
                    return
                }

                const values = data.map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return (Number(prev) + Number(curr)).toFixed(3);
                        } else {
                            return prev;
                        }
                    }, 0);
                } else {
                    sums[index] = '';
                }
            });

            return sums;
        },
        objectSpanMethod({ column, rowIndex, columnIndex }) {
            for (let res in this.needMergeArr) {
                if (this.needMergeArr[res] == column.property) {
                    return this.mergeAction(column.property, rowIndex, columnIndex);
                }
            }
        },
        mergeAction(val, rowIndex) {
            let _row = this.rowMergeArrs[val]['rowArr'][rowIndex];
            let _col = _row > 0 ? 1 : 0;
            return [_row, _col];
        },
        rowMergeHandle(arr, data) {
            if (!Array.isArray(arr) && !arr.length) return false;
            if (!Array.isArray(data) && !data.length) return false;
            let needMerge = {};
            arr.forEach((i, idx) => {
                needMerge[i] = {
                    rowArr: [],
                    rowMergeNum: 0,
                };

                if (idx == 0) {
                    data.forEach((item, index) => {
                        // 表格首个数据单独处理
                        if (index === 0) {
                            needMerge[i].rowArr.push(1);
                            needMerge[i].rowMergeNum = 0;
                        } else {
                            if (item[i] === data[index - 1][i]) {
                                needMerge[i].rowArr[needMerge[i].rowMergeNum] += 1;
                                needMerge[i].rowArr.push(0);
                            } else {
                                needMerge[i].rowArr.push(1);
                                needMerge[i].rowMergeNum = index;
                            }
                        }
                    });
                } else {
                    let firstRowArr = needMerge[arr[0]].rowArr;
                    let firstRowArrDeal = [];
                    firstRowArr.forEach((item, index) => {
                        if (item > 0) {
                            firstRowArrDeal.push(index);
                        }
                    });
                    data.forEach((item, index) => {
                        let sign = false;
                        if (firstRowArrDeal.indexOf(index) > 0) {
                            needMerge[i].rowMergeNum = index;
                            sign = true;
                        }
                        // 表格首个数据单独处理
                        if (index === 0) {
                            needMerge[i].rowArr.push(1);
                            needMerge[i].rowMergeNum = 0;
                        } else {
                            if (item[i] === data[index - 1][i]) {
                                if (sign) {
                                    needMerge[i].rowArr.push(1);
                                } else {
                                    if (item[arr[idx - 1]] != data[index - 1][arr[idx - 1]]) {
                                        needMerge[i].rowArr.push(1);
                                        needMerge[i].rowMergeNum = index;
                                    } else {
                                        needMerge[i].rowArr[needMerge[i].rowMergeNum] += 1;
                                        needMerge[i].rowArr.push(0);
                                    }
                                }
                            } else {
                                needMerge[i].rowArr.push(1);
                                needMerge[i].rowMergeNum = index;
                            }
                        }
                    });
                }
            });
            return needMerge;
        },

    }
};
</script>
  